import * as React from "react";
const SvgBullet = props => <svg width="18px" height="18px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx={9} cy={9} r={3} fill="currentColor" fillRule="evenodd" /></svg>;
export default SvgBullet;